package club.srams.website.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAboutPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("About.md", FrontMatterElement.Builder { addScalar("title", "About"); }))
}

@Page("/about")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun AboutPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("shelton-rock-and-mineral-society") }) {
        org.jetbrains.compose.web.dom.Text("Shelton Rock and Mineral Society")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Est. January 1961 · 501(c)(7) Nonprofit")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Shelton Rock and Mineral Society is a 501(c)(7) social nonprofit founded in January 1961. We are made up entirely of volunteers who share a passion for rocks, minerals, geology, and lapidary arts. We meet monthly — every month except December — to learn, share, and connect with fellow enthusiasts across the region.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.Table {
        org.jetbrains.compose.web.dom.Thead {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Founded")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Membership")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Meetings")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Affiliation")
                }
            }
        }
        org.jetbrains.compose.web.dom.Tbody {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("January 1961")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("All volunteers")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Monthly (except December)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("WA State Mineral Council")
                }
            }
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("what-we-re-about") }) {
        org.jetbrains.compose.web.dom.Text("What We're About")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Learning about rocks and minerals and where they can be found across our region and beyond.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Exploring the geology behind how rocks and minerals are formed.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Discovering, appreciating, and preserving the full range of lapidary skills and art.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Promoting the safe use of equipment, tools, and materials in all our activities.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Sharing information about upcoming rock and mineral shows and events throughout the area.")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("club-activities") }) {
        org.jetbrains.compose.web.dom.Text("Club Activities")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Annual Tailgate Swap")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Club auctions")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Meeting programs")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Field trips to local collection sites")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Rock and mineral show announcements")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Annual Members Picnic")
            }
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("We do not provide formal appraisal services. However, our experienced members are happy to help point you toward identification resources or offer a general assessment of what you've found.")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("how-do-i-become-a-member") }) {
        org.jetbrains.compose.web.dom.Text("How do I become a member?")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("meetings") }) {
        org.jetbrains.compose.web.dom.Text("Meetings")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The best way to join would be to attend a general meeting, talk with a board member, and fill out a membership form:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Location: Shelton Christian Church, 115 Arcadia Ave, Shelton, WA")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("When: 7:00 PM on the last Thursday of each month (with exceptions for holidays)")
            }
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("dues") }) {
        org.jetbrains.compose.web.dom.Text("Dues")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The best way to join would be to attend a general meeting:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Membership costs ${'$'}10.00 per adult per year, collected by the Membership Chairperson")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("After 20 consecutive years of paid dues, you are granted a lifetime membership")
            }
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("images/logo-small.jpg", "logo-small.jpg")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("board-of-directors") }) {
        org.jetbrains.compose.web.dom.Text("Board of Directors")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The board of directors for 2026:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("President")
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
                org.jetbrains.compose.web.dom.Text(" Pete Brush")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("1st Vice President")
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
                org.jetbrains.compose.web.dom.Text(" Paul Corbett")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("2nd Vice President")
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
                org.jetbrains.compose.web.dom.Text(" Stacy Sedlacek")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("Secretary")
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
                org.jetbrains.compose.web.dom.Text(" Linda VenEman")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("Treasure")
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
                org.jetbrains.compose.web.dom.Text(" Leslie Perrault")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("Trustees")
                }
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
                org.jetbrains.compose.web.dom.Text(" Travis Twiddy ")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
                org.jetbrains.compose.web.dom.Text(" Jim Curtiss ")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
                org.jetbrains.compose.web.dom.Text(" Jennifer Shipley ")
                com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
            }
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H4(attrs = { id("email-address") }) {
        org.jetbrains.compose.web.dom.Text("Email Address")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:info@srams.club") {
            org.jetbrains.compose.web.dom.Text("info@srams.club")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H4(attrs = { id("postal-address") }) {
        org.jetbrains.compose.web.dom.Text("Postal Address")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Shelton Rock and Mineral Society")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
        org.jetbrains.compose.web.dom.Text(" PO Box 242")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
        org.jetbrains.compose.web.dom.Text(" Shelton, WA  98584")
    }
}
